import loginService from "@/api/loginService";
import router from '@/router/index'
import Nprogress from 'nprogress'
const state = {
    token: localStorage.getItem('access_token') || null,
    errMsg: ""
}
const getters = {
    errMsg: state => state.errMsg
};
const actions = {
    login({ commit }, credentials) {
        // localStorage.removeItem('isActive');
        console.log("login")
        commit('login', credentials)
    },
    logout({ commit }) {

        localStorage.removeItem('access_token');
        commit('logout');
        router.push('/');
        state.errMsg = ""
        location.reload();
    }
}
const mutations = {
    logout: (state) => {
        state.token = null;
        state.errMsg = ""
    },
    async login(state, credentials) {
        try {
            Nprogress.start()
            var response = await loginService.login(credentials);
            const token = response.data.token;
            localStorage.setItem('access_token', token);
            state.token = token;
            router.push("/dashboard");

            // console.log(response);

        } catch (err) {
            console.log(err.response.status == 400)
            if (err.response.status == 400) {
                Nprogress.done()
                state.errMsg = "Username or password is incorrect";
            }
        }
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}